var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#led-search_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.595 4.14V1.446a.781.781 0 111.562 0v1.942A8.181 8.181 0 0111.797 0c4.524 0 8.204 3.68 8.204 8.203a.781.781 0 11-1.563 0 6.648 6.648 0 00-6.64-6.64A6.603 6.603 0 006.263 4.53h1.98a.781.781 0 110 1.563H5.548A1.955 1.955 0 013.595 4.14zm14.453 6.173h-2.695a.781.781 0 100 1.562h1.98a6.603 6.603 0 01-5.535 2.969 6.648 6.648 0 01-6.64-6.64.781.781 0 10-1.563 0c0 1.99.712 3.816 1.895 5.238L.232 18.664a.781.781 0 001.1 1.11l5.266-5.23a8.165 8.165 0 005.2 1.862 8.181 8.181 0 006.64-3.387v1.942a.781.781 0 101.563 0v-2.695a1.955 1.955 0 00-1.953-1.954z",
    fill: "#182341"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "led-search_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgLedSearch;